import { render, staticRenderFns } from "./add-zone-delivery-rate-popup.vue?vue&type=template&id=7c6a7830"
import script from "./add-zone-delivery-rate-popup.vue?vue&type=script&lang=js"
export * from "./add-zone-delivery-rate-popup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports